module.exports = __webpack_public_path__ + "img/pillaged_hut_small.fcc4a097.png";